import DrochkaExercisesAPI from '../../api/DrochkaExercisesAPI'

import * as types from '../ActionTypes'

let loadExercises_ = () => {
    return {
        type: types.LOAD_DROCHKA_EXERCISES
    }
}
let loadExercisesSuccess = (exercises) => {
    return {
        type: types.LOAD_DROCHKA_EXERCISES_SUCCESS,
        exercises: exercises
    }
}
let loadExercisesFailed = (error) => {
    return {
        type: types.LOAD_DROCHKA_EXERCISES_FAIL,
        error: error
    }
}

//thunk
export function getExercisesByIds(exercisesIds = []) {
    return (dispatch, getState) => {
        dispatch(loadExercises_());
        return DrochkaExercisesAPI.getDrochkaExercisesByIds(exercisesIds).then(
            exercises => dispatch(loadExercisesSuccess(exercises)),
            error => dispatch(loadExercisesFailed(error))
        )
    }
}

//thunk
export function getAllDrochkaExercises(exercisesIds = []) {
    return (dispatch, getState) => {
        dispatch(loadExercises_());
        return DrochkaExercisesAPI.getAllDrochkaExercises().then(
            exercises => dispatch(loadExercisesSuccess(exercises)),
            error => dispatch(loadExercisesFailed(error))
        )
    }
}

export function loadExerciseById(id) {
    return (dispatch, getState) => {
        dispatch(loadExercises_());
        return DrochkaExercisesAPI.getDrochkaExercise(id).then(
            exercise => dispatch(loadExercisesSuccess([exercise])),
            error => dispatch(loadExercisesFailed(error))
        )
    }
}

let createExercise_ = () => {
    return {
        type: types.CREATE_DROCHKA_EXERCISE
    }
}
let createExerciseSuccess = (exercise) => {
    return {
        type: types.CREATE_DROCHKA_EXERCISE_SUCCESS,
        exercise: exercise
    }
}
let createExerciseFailed = (error) => {
    return {
        type: types.CREATE_DROCHKA_EXERCISE_FAIL,
        error: error
    }
}

//thunk
export function createExercise(data) {
    return (dispatch, getState) => {
        dispatch(createExercise_());
        return DrochkaExercisesAPI.createDrochkaExercise(data).then(
            exercise => dispatch(createExerciseSuccess(exercise)),
            error => dispatch(createExerciseFailed(error))
        )
    }
}

let updateExercise_ = () => {
    return {
        type: types.UPDATE_DROCHKA_EXERCISE
    }
}
let updateExerciseSuccess = (exercise) => {
    return {
        type: types.UPDATE_DROCHKA_EXERCISE_SUCCESS,
        exercise: exercise
    }
}
let updateExerciseFailed = (error) => {
    return {
        type: types.UPDATE_DROCHKA_EXERCISE_FAIL,
        error: error
    }
}

//thunk
export function updateExercise(data) {
    return (dispatch, getState) => {
        dispatch(updateExercise_());
        return DrochkaExercisesAPI.updateDrochkaExercise(data).then(
            exercise => dispatch(updateExerciseSuccess(exercise)),
            error => dispatch(updateExerciseFailed(error))
        )
    }
}

let deleteExercise_ = () => {
    return {
        type: types.DELETE_DROCHKA_EXERCISE
    }
}
let deleteExerciseSuccess = (id) => {
    return {
        type: types.DELETE_DROCHKA_EXERCISE_SUCCESS,
        id: id
    }
}
let deleteExerciseFailed = (error) => {
    return {
        type: types.DELETE_DROCHKA_EXERCISE_FAIL,
        error: error
    }
}

//thunk
export function deleteExercise(id) {
    return (dispatch, getState) => {
        dispatch(deleteExercise_());
        return DrochkaExercisesAPI.deleteExercise(id).then(
            () => dispatch(deleteExerciseSuccess(id)),
            error => dispatch(deleteExerciseFailed(error))
        )
    }
}
